/**
 * Minimal message catalog for the marketing site. Pages look copy up by a
 * dotted key (`t('lighthouse.hero.title')`) instead of hardcoding it, so a
 * second locale can be added later by swapping the catalog. Keys are typed
 * from the JSON, so a missing or misspelled key fails `tsc`.
 */
import en from './messages/en.json';

type Leaves<T, P extends string = ''> = {
  [K in keyof T & string]: T[K] extends string ? `${P}${K}` : Leaves<T[K], `${P}${K}.`>;
}[keyof T & string];

export type MessageKey = Leaves<typeof en>;

export function t(key: MessageKey): string {
  let node: unknown = en;
  for (const part of key.split('.')) {
    node = (node as Record<string, unknown>)[part];
  }
  return node as string;
}
